import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';


import ginoPartyJollof70g from "../../public/category-img/paste/GinoPartyjollof70g.jpeg"; 
import GinoPepperOnion70g from "../../public/category-img/paste/SPRSI73110_3b2ee1cd-a37b-43cc-9965-f439427278db_300x@2x.jpg"; 
import GinoTomatoPaste70g from "../../public/category-img/paste/Gino TomatoPaste70g.jpeg"; 
import GinoTomatoPaste210g from "../../public/category-img/paste/Gino TomatoPaste70g.jpeg"; 
import GinoTomatoPaste400g from "../../public/category-img/paste/GinoTomatoPaste400g_prev_ui.png"; 
import GinoTomatoPaste800g from "../../public/category-img/paste/gino-tomato-paste-800g.jpg"; 
import DeRicaTomatoPaste70g from "../../public/category-img/paste/DeRicaTomatoPaste70g.jpg"; 
import DeRicaTomatoPaste210g from "../../public/category-img/paste/DeRicaTomatoPaste210g.jpg"; 
import DeRicaTomatoPaste400g from "../../public/category-img/paste/DeRicaTomatoPaste400g.jpg"; 
import  DeRicaTomatoPaste800g from "../../public/category-img/paste/DeRicaTomatoPaste800g.jpg"; 
import SoniaTomatoMix70g from "../../public/category-img/paste/SoniaTomatoMix70g.jpeg"; 
import SoniaPepperOnion70g from "../../public/category-img/paste/soniapepperonion70g.jpeg"; 
import SoniaTomatoMix210g_sachet from "../../public/category-img/paste/SoniaTomatoMix210g(sachet).jpeg"; 



export const pasteproducts = [
  { id: 'PST001', name: 'Gino Party Jollof 0.15 lbs', brand: 'Gino', price: '$2.00', img: ginoPartyJollof70g, description: 'Gino Party Jollof is a rich and flavorful tomato paste specially crafted for making party-style jollof rice. This premium tomato paste is packed with the perfect balance of tomatoes and spices, designed to bring out the authentic, vibrant taste of jollof rice. Gino Party Jollof helps create a rich, aromatic base for your rice, ensuring your dish has the perfect color, texture, and flavor.' },
  { id: 'PST002', name: 'Gino Pepper & Onion 0.15 lbs', brand: 'Gino', price: '$2.00', img: GinoPepperOnion70g, description: 'Gino Pepper & Onion Tomato Paste is a rich, flavorful tomato paste infused with the perfect blend of peppers and onions. Ideal for creating bold, aromatic African dishes like stews, sauces, and rice, it enhances the taste with a deep, savory flavor and vibrant color.' },
  { id: 'PST003', name: 'Gino Tomato Paste 0.15 lbs', brand: 'Gino', price: '$2.00', img: GinoTomatoPaste70g, description: 'Gino Tomato Mix is a rich and flavorful tomato paste, expertly blended with the perfect combination of tomatoes and spices. Ideal for making African dishes like stews, sauces, and jollof rice, it provides a deep, savory flavor and vibrant color.' },
  { id: 'PST004', name: 'Gino Tomato Paste 0.46 lbs', brand: 'Gino', price: '$3.95', img: GinoTomatoPaste210g, description: 'Gino Tomato Mix is a rich and flavorful tomato paste, expertly blended with the perfect combination of tomatoes and spices. Ideal for making African dishes like stews, sauces, and jollof rice, it provides a deep, savory flavor and vibrant color.' },
  { id: 'PST005', name: 'Gino Tomato Paste 0.88 lbs', brand: 'Gino', price: '$4.50', img: GinoTomatoPaste400g, description: 'Gino Tomato Mix is a rich and flavorful tomato paste, expertly blended with the perfect combination of tomatoes and spices. Ideal for making African dishes like stews, sauces, and jollof rice, it provides a deep, savory flavor and vibrant color.' },
  { id: 'PST006', name: 'Gino Tomato Paste 1.76 lbs', brand: 'Gino', price: '$5.50', img: GinoTomatoPaste800g, description: 'Gino Tomato Mix is a rich and flavorful tomato paste, expertly blended with the perfect combination of tomatoes and spices. Ideal for making African dishes like stews, sauces, and jollof rice, it provides a deep, savory flavor and vibrant color.' },
  { id: 'PST007', name: 'De Rica Tomato Paste 0.15 lbs', brand: 'Derica', price: '$1.59', img: DeRicaTomatoPaste70g, description: 'Derica Tomato Paste is a rich and thick tomato paste made from finely ground tomatoes, offering a vibrant color and deep, concentrated flavor. Perfect for enhancing the taste of African dishes like stews, sauces, jollof rice, and soups, it provides a rich, savory base for your meals.' },
  { id: 'PST008', name: 'De Rica Tomato Paste 0.46 lbs', brand: 'Derica', price: '$2.89', img: DeRicaTomatoPaste210g, description: 'Derica Tomato Paste is a rich and thick tomato paste made from finely ground tomatoes, offering a vibrant color and deep, concentrated flavor. Perfect for enhancing the taste of African dishes like stews, sauces, jollof rice, and soups, it provides a rich, savory base for your meals.' },
  { id: 'PST009', name: 'De Rica Tomato Paste 0.88 lbs', brand: 'Derica', price: '$3.95', img: DeRicaTomatoPaste400g, description: 'Derica Tomato Paste is a rich and thick tomato paste made from finely ground tomatoes, offering a vibrant color and deep, concentrated flavor. Perfect for enhancing the taste of African dishes like stews, sauces, jollof rice, and soups, it provides a rich, savory base for your meals.' },
  { id: 'PST010', name: 'De Rica Tomato Paste 1.76 lbs', brand: 'Derica', price: '$5.50', img: DeRicaTomatoPaste800g, description: 'Derica Tomato Paste is a rich and thick tomato paste made from finely ground tomatoes, offering a vibrant color and deep, concentrated flavor. Perfect for enhancing the taste of African dishes like stews, sauces, jollof rice, and soups, it provides a rich, savory base for your meals.' },
  { id: 'PST011', name: 'Sonia Tomato Mix 0.15 lbs', brand: 'Sonia Food', price: '$2.00', img: SoniaTomatoMix70g, description: 'Sonia Tomato Paste Mix is a rich, flavorful tomato paste blended with a mix of spices and seasonings, designed to enhance your African dishes. Ideal for stews, sauces, soups, and jollof rice, it provides a vibrant color and deep, savory flavor.' },
  { id: 'PST012', name: 'Sonia Pepper & Onion 0.15 lbs', brand: 'Sonia Food', price: '$2.00', img: SoniaPepperOnion70g, description: 'Sonia Pepper & Onion Tomato Paste is a flavorful tomato paste infused with a perfect blend of peppers and onions. It adds a rich, savory taste and vibrant color to your dishes, making it ideal for African recipes like stews, soups, sauces, and jollof rice.' },
  { id: 'PST013', name: 'Sonia Tomato Mix 0.46 lbs (sachet)', brand: 'Sonia Food', price: '$3.87', img: SoniaTomatoMix210g_sachet, description: 'Sonia Tomato Paste Mix is a rich, flavorful tomato paste blended with a mix of spices and seasonings, designed to enhance your African dishes. Ideal for stews, sauces, soups, and jollof rice, it provides a vibrant color and deep, savory flavor.' },
  { id: 'PST014', name: 'Sonia Tomato Mix 2.43 lbs (sachet)', brand: 'Sonia Food', price: '$6.55', img: SoniaTomatoMix210g_sachet, description: 'Sonia Tomato Paste Mix is a rich, flavorful tomato paste blended with a mix of spices and seasonings, designed to enhance your African dishes. Ideal for stews, sauces, soups, and jollof rice, it provides a vibrant color and deep, savory flavor.' }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const Paste = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = pasteproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'pasteproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('pasteproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Paste Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Paste;